import { render, staticRenderFns } from "./SuccessStoriesList.vue?vue&type=template&id=125992c8&scoped=true"
import script from "./SuccessStoriesList.vue?vue&type=script&lang=js"
export * from "./SuccessStoriesList.vue?vue&type=script&lang=js"
import style0 from "./SuccessStoriesList.vue?vue&type=style&index=0&id=125992c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125992c8",
  null
  
)

export default component.exports